/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { Copy, BodyCopy, Icon } from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from './requeststatus_styles';



/* ========== ~~~~~~~~~~ COMMENT APPROVAL REQUEST RECEIVED ~~~~~~~~~~ ========== */
const RequestReceived = (props) =>{
    return (
        <div className={`requeststatus ${props.classes.requeststatus}`}>
            <Copy>
                <BodyCopy>
                    <div className={'title'}>Request received!</div>
                    <p>Your account manager will be in touch with you shortly.</p>
                    <ul>
                        <li>
                            <span>
                                We are gradually rolling this feature out to our customers.
                                We will send an email confirmation to <strong>{props.email}</strong> when the commenting functionality is activated in your account.
                            </span>
                        </li>
                        <li>
                            <span>
                                In the meantime, feel free to reach out to <a href="mailto:am-department@insticator.com">am-department@insticator.com</a> if you have any further questions.
                            </span>
                        </li>
                    </ul>
                </BodyCopy>
                <Icon name={'check-circle'} />
            </Copy>
        </div>
    )
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(RequestReceived);
